module.exports = __webpack_public_path__ + "img/labelItem1@2x.10b033cb.png";